import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow } from "swiper/modules";
import sample from "../Css/Backgrounds/photo_2.jpg";
import sample1 from "../Css/Backgrounds/photo_3.jpg";
import sample2 from "../Css/Backgrounds/photo_12.jpg";
import sample3 from "../Css/Backgrounds/photo_5.jpg";
import sample4 from "../Css/Backgrounds/photo_6.jpg";
import sample5 from "../Css/Backgrounds/photo_7.jpg";
import sample6 from "../Css/Backgrounds/photo_8.jpg";
import sample7 from "../Css/Backgrounds/photo_9.jpg";
import sample8 from "../Css/Backgrounds/photo_10.jpg";
import sample9 from "../Css/Backgrounds/photo_11.jpg";
import { FaArrowRight } from "react-icons/fa";
import { FaArrowLeft } from "react-icons/fa";

function Gallery(props) {
  const [swiperController, setSwiperController] = useState("");

  return (
    <>
      <button
        className="prevSlide"
        onClick={() => {
          swiperController.slideNext();
        }}
      >
        <FaArrowLeft />
      </button>
      <Swiper
        centeredSlides
        spaceBetween={10}
        grabCursor={true}
        loop={true}
        modules={[EffectCoverflow]}
        className="mySwiper"
        onSwiper={setSwiperController}
        direction={"horizontal"}
        onSlideChange={(swiper) => {
          // console.log(swiper);
        }}
      >
        <SwiperSlide>
          <div className="imgContainer">
            <img src={sample} alt={"تصاویر آبنوس"} />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="imgContainer">
            <img src={sample1} alt={"تصاویر آبنوس"} />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="imgContainer">
            <img src={sample2} alt={"تصاویر آبنوس"} />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="imgContainer">
            <img src={sample3} alt={"تصاویر آبنوس"} />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="imgContainer">
            <img src={sample4} alt={"تصاویر آبنوس"} />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="imgContainer">
            <img src={sample5} alt={"تصاویر آبنوس"} />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="imgContainer">
            <img src={sample6} alt={"تصاویر آبنوس"} />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="imgContainer">
            <img src={sample7} alt={"تصاویر آبنوس"} />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="imgContainer">
            <img src={sample8} alt={"تصاویر آبنوس"} />
          </div>
        </SwiperSlide>
      </Swiper>
      <button
        className="nextSlide"
        onClick={() => {
          swiperController.slidePrev();
        }}
      >
        <FaArrowRight />
      </button>
    </>
  );
}

export default Gallery;
